<style lang="scss" src="./Projects.scss"></style>

<template>
    <div class="wrapper" v-bind:class="{'project-loaded': projectLoaded, 'project-loading': projectLoading}">        
        <div class="projects-wrapper">
            <div class="projects-inner" id="projects-container">
                <div class="projects-counter" v-bind:class="{'is-hidden': sliderNavHidden || isList}" >
                    <ul class="list list--counter" id="projects-counter" data-counter="1" ref="projectsCounter">
                        <li class="project-1">1</li>
                        <li class="project-2">2</li>
                        <li class="project-3">3</li>
                        <li class="project-4">4</li>
                    </ul>
                    <p class="counter-total">/ 4</p>
                </div>
                <div class="scroll-info" v-bind:class="{'is-hidden': sliderNavHidden || isList || app.isProjectsScrolled}">scroll</div>
                <ul class="list list--toggle projects-toggle">
                    <li v-on:click="filterFull()" class="list-item icon-full is-hoverable c-hover" v-bind:class="{active: !isList}">
                        <span class="icon-part full-1 c-hover"></span>
                        <span class="icon-part full-2 c-hover"></span>
                    </li>
                    <li v-on:click="filterList()" class="list-item icon-list is-hoverable c-hover" v-bind:class="{active: isList}">
                        <span class="icon-part list-1 c-hover"></span>
                        <span class="icon-part list-2 c-hover"></span>
                    </li>
                </ul>
                <div class="slider slider--primary list list--secondary list--projects" id="slider-projects" v-bind:class="{'l-list': isList, 'l-full': isFull}">
                    <ul>
                        <project-list-item v-for="(value, index) of projects" :project_id="index" :data-name="index" :data-id="Object.keys(projects).indexOf(index)" :project_data="value" v-bind:key="value.id"></project-list-item>
                    </ul>
                    <div class="slider-nav" ref="navElement" v-bind:class="{'is-hidden': sliderNavHidden}">
                        <div class="slider-button slider-prev is-hoverable c-arrowLeft">
                            <span class="button-label">{{ t('prev') }}</span>
                        </div>
                        <div class="slider-button slider-next is-hoverable c-arrowRight">
                            <span class="button-label">{{ t('next') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <transition name="fade" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
            <router-view class="animated"></router-view>
        </transition>
    </div>
</template>

<script>

    import projects from '../../data/projects.json'
    import projectListItem from '../ProjectListItem/ProjectListItem.vue'
    import AssetsLoader from 'assets-loader'
    import LoaderMixin from '../Loader/LoaderMixin.js'
    import '../../assets/js/slider.js'

    export default {
        
        mixins: [LoaderMixin],
        
        components: {
            'project-list-item': projectListItem
        },
        
        metaInfo () {
            return {
                title: 'Julien Barreira',
                titleTemplate: '%s - ' + this.$translate.locale.job
            }
        },

        data() {
            return {
                projects,
                isList: false,
                isFull: false,
                isAnimating: false,
                projectLoading: false,
                projectLoaded: false,
                app: this.$parent,
                initCanvasSlideshow: false,
                loaderRef: this.$parent.$refs.appbase.$refs.loader,
                sliderNavHidden: false,
                titleSplitted: false
            }
        },
        
        mounted() {
            var self = this
            
            if (this.$route.name.includes('project_component')) {
                
                this.projectLoaded = true
            }
            
            this.$nextTick(function () {
                setTimeout(function() {
                    if (!self.app.isMobile) {                        
                        self.sliderInit()
                    }
                    
                }, 100);
            })
            
            // On resize
            window.addEventListener('resize', this.resizeCanvas)
        },
        
        locales: {
            en: {
                'prev': 'prev.',
                'next': 'next',
                'job': 'Front-End Developer'
            },
            fr: {
                'prev': 'préc.',
                'next': 'suiv.',
                'job': 'Développeur Front-End'
            }
        },
                        
        beforeRouteLeave (to, from, next) {
            
            // condition pour éviter bug en cas de changement de page en plein switch full/list
            if (!this.isAnimating) {
                
                next(false)                
                
                if (to.name.includes('projects_component') || to.name.includes('project_component')) {           

                    next()
                    
                } else {
                    
                    window.removeEventListener('resize', this.resizeCanvas)
                    
                    if (!this.app.isMobile) {
                        this.initCanvasSlideshow.destroy();
                    }
                    // on initialise le loader
                    let assetsLoader = AssetsLoader()
                    this.loadContent(this, assetsLoader, to, next, this.app)          
                }
            }
        },
        
        methods: {
            filterFull: function () {
                
                if (!this.loaderRef.isLoading && !this.projectLoaded) {
                    
                    var isPlaying = this.initCanvasSlideshow.checkIfPlaying();
                    

                    if (!this.isAnimating && this.isList && !isPlaying) {
                        this.blockAnimation()
                        this.sliderNavHidden = false

                        var self = this
                        
                        // la fonction gère aussi le isList/isFull et le allowAnimation
                        this.initCanvasSlideshow.filterFull();
                    }
                }
            },
            filterList: function () {
                if (!this.loaderRef.isLoading && !this.projectLoaded) {
                    
                    var isPlaying = this.initCanvasSlideshow.checkIfPlaying()
                    

                    if (!this.isAnimating && !this.isList && !isPlaying) {
                        this.blockAnimation()
                        this.sliderNavHidden = true
                        
                        var self = this
                        
                        // la fonction gère aussi le isList/isFull et le allowAnimation
                        this.initCanvasSlideshow.filterList();
                    }
                }
            },
            blockAnimation: function() {
                this.isAnimating = true
            },
            allowAnimation: function() {
                this.isAnimating = false
            },
            sliderInit: function() {
                
                // slider
                var container = document.getElementById('projects-container');
                var projectsSlider = document.getElementById('slider-projects');
                var projects = projectsSlider.querySelectorAll('.slider-item');
                var spriteImages = projectsSlider.querySelectorAll('.item-image');
                var spriteImagesSrc = [];

                for (var i = 0; i < spriteImages.length; i++) {
                    var img = spriteImages[i];
                    spriteImagesSrc.push(img.getAttribute('src'));
                }
                
                // init slider
                this.initCanvasSlideshow = new CanvasSlideshow({
                    sprites: spriteImagesSrc,
                    displacementImage: '/static/images/clouds.jpg',
                    projects: Array.prototype.slice.call(projects, 0),
                    projectsCounter: this.$refs.projectsCounter,
                    container: container,
                    app: this,
                    navElement: this.$refs.navElement
                });                
            },
            
            resizeCanvas: function() {                
                if (window.innerWidth < 1025) {
                    if (this.initCanvasSlideshow !== false) {
                        this.initCanvasSlideshow.destroy()
                        this.initCanvasSlideshow = false
                        
                        if (!this.$route.name.includes('project_component')) {
                            Array.from(document.getElementById('slider-projects').getElementsByClassName('list-item')).forEach(function(element) {
                                element.classList.remove('is-active')
                            })
                        }
                    }
                } else {
                    if (this.initCanvasSlideshow === false) {
                        this.sliderInit()
                    }
                }
            }
        }
        
    }

</script>


// WEBPACK FOOTER //
// src/components/Projects/Projects.vue